import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from "@angular/common/http";
import {Observable} from "rxjs";
import {OrganizationTypePersistRequest} from "../model/requests/organization-type-persist-request";

@Injectable({
  providedIn: 'root'
})
export class OrganizationTypesService {

  private readonly organizationTypesURL: string;


  constructor(private http: HttpClient) {
    this.organizationTypesURL = '/api/organization_types';
  }

  public getOrganizationTypes(): Observable<any> {
    return this.http.get<any>(this.organizationTypesURL);
  }

  public createOrganizationType(organizationTypeData: OrganizationTypePersistRequest): Observable<any> {
    return this.http.post<any>(this.organizationTypesURL, organizationTypeData);
  }

  public editOrganizationType(organizationTypeData: OrganizationTypePersistRequest): Observable<any> {
    const url: string = `${this.organizationTypesURL}/${organizationTypeData.organizationTypeUuid}`;
    return this.http.put<any>(url, organizationTypeData);
  }

  public deleteOrganizationType(organizationTypeUuid: string): Observable<HttpResponse<any>> {
    const url: string = `${this.organizationTypesURL}/${organizationTypeUuid}`;
    return this.http.delete<any>(url, {observe: 'response'});
  }

}
